import { useCallback, useContext } from 'react';
import {
  AuthContext,
  clearBonusCode,
  setBonusCode,
  useApi,
} from '@repo-level/core-front';
import { REASON_FOR_UPDATING_USER } from '@repo-level/core-front/contexts/auth/reducer';

import { ModalsContext, ModalType } from 'contexts/modal';

export const useHandleBonus = (code: string | null | undefined) => {
  const { user, fetchUser, pendingUser } = useContext(AuthContext);
  const { handleModal } = useContext(ModalsContext);

  const [requestsSetBonusCode, { pending: pendingSetBonusCode }] = useApi(
    setBonusCode
  );
  const [requestClearBonusCode, { pending: pendingClearBonusCode }] = useApi(
    clearBonusCode
  );

  const handleBonus = useCallback(async () => {
    if (!!user?.canIssueBonuses) {
      const requestApi = code
        ? requestsSetBonusCode({
            depositBonusCode: code,
          })
        : requestClearBonusCode();

      const { error } = await requestApi.request;

      if (error != null) return;

      await fetchUser(REASON_FOR_UPDATING_USER.DEPOSIT);
    }

    handleModal(ModalType.Deposit)();
  }, [
    handleModal,
    user?.canIssueBonuses,
    code,
    fetchUser,
    requestsSetBonusCode,
    requestClearBonusCode,
  ]);

  return {
    handleBonus,
    pendingBonus: pendingSetBonusCode || pendingClearBonusCode || pendingUser,
  };
};
